import React, { Component } from 'react'
import { checkTextTranslation, getObject, imageAddress, priceStandardView, setObject, translate } from '../../utils/useful'
import PriceInput from './PriceInput'
import TextInput from './TextInput'
import SidebarView from '../SidebarView'
import RowTableInvoice from './RowTabeInvoice'
import Collapsible from 'react-collapsible'
import SelectInput from './SelectInput'
import { countriesList } from '../../variables/countries'
import CheckboxInput from './CheckboxInput'

class InvoiceInput2 extends Component {

    state = {
        errors: {},
        data: {},
        width: window.innerWidth,
        tab: 1
    }

    componentDidMount() {
        let countries = countriesList
        let currenciesItems = []
        countries.forEach(country => {
            let currencyItem = { title: `${country.currency} (${country.symbol})`, value: country.code }
            currenciesItems.push(currencyItem)
        });
        // let header = {key: 'currency', type: 'SelectInput', information: { label: 'Currency', type: 'local', items: currenciesItems, placeholder: '{{lang}}Currency', required: true }}
        // formHeaders = header
        this.setState({ currenciesItems })
        this.init()
        window.addEventListener('resize', this.setFormWidth);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.setFormWidth)
    }

    componentDidUpdate(prevProps) {
        if ((this.props.initData !== prevProps.initData) || (this.props.headers !== prevProps.headers)) {
            this.init()
        }
    }

    getForm = () => {
        if (this.validator()) {
            return this.state.data ? this.state.data : {}
        } else {
            return null
        }
    }

    init = () => {
        this.makeInitValue(this.props.initData)
    }

    validator() {
        let valid = true
        let errors = {}
        this.props.headers.forEach(header => {
            if (header.information?.required) {
                let value = getObject(this.state.data, header.key)
                if (header.type == 'ImageInput' || header.type == 'FileInput') {
                    if (!value || value === '') {
                        value = getObject(this.state.data, ('**files.' + header.key), 1)
                    }
                    if (!value || value === '') {
                        valid = false
                        errors[header.key] = '{{lang}}errors.required-field'
                    }
                } else {
                    if (!value || value === '') {
                        valid = false
                        errors[header.key] = '{{lang}}errors.required-field'
                    }
                }
                if (header.type == 'PhoneInput') {
                    if (!value || value.length < 14) {
                        valid = false
                        errors[header.key] = '{{lang}}errors.required-field'
                    }
                }
            }
        })
        this.setState({ errors })
        return valid
    }

    makeInitValue(rawData) {
        let data = rawData
        if (data == null) {
            data = {}
        }
        if (this.props.headers) {
            this.props.headers.forEach(header => {
                if (data[header.key] == null && header.information?.default != null) {
                    data[header.key] = header.information?.default
                }
            });
        }
        this.setState({ data: data, show: true }, () => {
            this.setFormWidth()
        })
    }

    setFormWidth = () => {
        if (this.form) {
            this.setState({ width: this.form.getBoundingClientRect().width })
        }
    }

    addNew = () => {
        let data = this.props.data
        if (!data) {
            data = {}
        }
        if (!Array.isArray(data.items)) {
            data.items = []
        }
        data.items.push({})
        this.props.changeValue(this.props.header.key, data)
    }

    addNew1 = () => {
        let data = this.props.data
        if (!data) {
            data = {}
        }
        if (!Array.isArray(data.items)) {
            data.items = []
        }
        data.items.push({})
        this.props.changeValue(this.props.header.key, data)
        this.fixedViewMore.hideView()
    }

    removeRow = (index) => {
        let data = this.props.data
        data.items.splice(index, 1)
        this.props.changeValue(this.props.header.key, data)
    }

    changeFiles = (files, key, extra) => {
        this.props.changeValue('**files', { [this.props.header.key + '.' + extra?.index + "~" + key]: files }, { append: 'object' })
    }

    changeValue = (key, value, extra, fullObject) => {
        let data = this.props.data.items
        let index = extra.index
        let oldValue = getObject(data, key, null, null, index)
        if (oldValue && typeof oldValue == 'object') {
            oldValue = oldValue?._id
        }
        if (Array.isArray(data)) {
            data = setObject(data, key, value, false, index)
            this.props.changeValue(this.props.header.key, { ...this.props.data, ...{ items: data } })
        }
        if (key == 'item') {
            if (oldValue != value) {
                this.changeValue('rate', (fullObject?.price ? Number(fullObject?.price) : 0), extra)
            }
            this.changeValue('unit', fullObject?.unit, extra)
            this.changeValue('image', fullObject?.image, extra)
        }
        if (key == 'rate') {
            let quantity = getObject(data, 'quantity', null, null, index)
            if (!quantity) {
                data = setObject(data, 'quantity', 1, false, index)
                quantity = 1
            }
            let amount = Number(value) * Number(quantity)
            this.changeValue('amount', Number(amount.toFixed(2)), extra)
        }
        if (key == 'quantity') {
            let rate = getObject(data, 'rate', null, null, index)
            let quantity = getObject(data, 'quantity', null, null, index)
            if (!rate) {
                rate = 0
            }
            if (!quantity || quantity == '') {
                quantity = 0
            }
            let amount = Number(rate) * Number(quantity)
            this.changeValue('amount', Number(amount.toFixed(2)), extra)
        }
        if (key == 'amount') {
            setTimeout(() => {
                this.updatePrices()
            }, 10);
        }
    }

    formColBuilder(col) {
        let finalCol = 'col-12'
        if (100 < this.state.width && col) {
            finalCol = 'col-' + col
        }
        return finalCol
    }

    renderHeader(headers) {
        if (headers) {
            return (headers.map((header, index) => {
                return (
                    <div key={index} className={" w-100 pt-1 pb-2 px-2 text-uppercase  " + (index != headers.length - 1 ? 'invoice-table-border ' : '') + (index == 0 ? 'text-start ' : 'text-center ') + this.formColBuilder(header.col)} >
                        <label style={{ color: '#000', fontWeight: '600' }} className={'text-smaller mrd-1 mld-1  ' + (header.information?.required ? 'required' : '')}>{checkTextTranslation(header.information?.label)}</label>
                        {header.information?.hint && (
                            <div className={"mx-1 text-start text-smallest "}>
                                <div style={{ color: '#9ab', fontWeight: '500' }}>{checkTextTranslation(header.information?.hint)}</div>
                            </div>
                        )}
                    </div>
                )
            }))
        }
    }

    changeShipping = (key, value) => {
        this.props.changeValue(this.props.header.key, { ...this.props.data, ...{ shipping: value } })
        setTimeout(() => {
            this.updatePrices()
        }, 10);
    }

    changeDiscount = (key, value) => {
        this.props.changeValue(this.props.header.key, { ...this.props.data, ...{ discount: value } })
        setTimeout(() => {
            this.updatePrices()
        }, 10);
    }

    updateAdjustment = (key, value) => {
        this.props.changeValue(this.props.header.key, { ...this.props.data, ...{ adjustment: value } })
        setTimeout(() => {
            this.updatePrices()
        }, 10);
    }

    updateAdjustmentTitle = (key, value) => {
        this.props.changeValue(this.props.header.key, { ...this.props.data, ...{ adjustmentTitle: value } })
    }

    updatePrices = () => {
        let subtotal = this.calcSubtotal()
        let total = subtotal - (this.props.data?.discount ?? 0) + (this.props.data?.shipping ?? 0) + (this.props.data?.tax ?? 0) + (this.props.data?.adjustment ?? 0)
        this.props.changeValue(this.props.header.key, { ...this.props.data, ...{ subtotal: subtotal, total } })
    }

    calcSubtotal = () => {
        let total = 0
        if (Array.isArray(this.props.data?.items)) {
            for (let i = 0; i < this.props.data?.items.length; i++) {
                const element = this.props.data.items[i];
                total = total + (element.amount ?? 0)
            }
        }
        return total
    }

    render() {
        let headers = this.props.header.information?.headers
        if (this.state.show) {
            return (
                <section className="w-100   pt-0" ref={(el) => this.form = el}>
                    <div className="row mt-2 mx-0">
                        <div className="flex-1 pld-5 px-0" >
                            <div className=" pb-4" style={{ flex: 1, }}>
                                <div className="flexc flex-1">
                                    <div className="mrd-3 w-100">
                                        <p className="font-size-14 weight-600 main-c2" style={{}}>{translate("Currency")}</p>
                                    </div>
                                    <div className='br-6 w-100' style={{ backgroundColor: '#fff', border: '1px solid #e2e2e2', padding: '4px 6px' }}>
                                        <SelectInput data={this.props.data?.currency} header={{ key: '', information: { items: this.state.currenciesItems } }} changeValue={() => { }} />
                                    </div>
                                </div>
                                <div className="flexc flex-1 py-2">
                                    <div className="mrd-3 w-100">
                                        <div>
                                            <p className="font-size-14 weight-600 main-c2" style={{}}>{translate("Price")}</p>
                                            <p className='font-size-12 main-c7'>$16 × 3seats × 12month</p>
                                        </div>
                                    </div>
                                    <p className='font-size-14 main-c2'>$576.00</p>
                                </div>
                                <div className="flexc flex-1 py-2">
                                    <div className="mrd-3 w-100">
                                        <p className="font-size-14 weight-600 main-c2" style={{}}>{translate("Offer")}</p>
                                    </div>
                                    <div className='flexc w-100' style={{ justifyContent: 'flex-end' }}>
                                        <div className='flexcc prd-2'>
                                            <label className="checkbox-container" >
                                                <input type="checkbox" onChange={(e) => this.changeInputValue(e.target)} checked={this.props.data ? this.props.data : false} />
                                                <p className="checkmark2"></p>
                                            </label>
                                        </div>
                                        <p className='font-size-14 main-c2'>{translate('View offer')}</p>
                                    </div>
                                </div>
                                <div className="flexc flex-1 py-2">
                                    <div className="mrd-3 w-100">
                                        <p className="font-size-14 weight-600 main-c2" style={{}}>{translate("Tax")}</p>
                                    </div>
                                    <div className='flexc w-100' style={{ justifyContent: 'flex-end' }}>
                                        <p className='font-size-14 main-c2'>S$46.08</p>
                                    </div>
                                </div>
                                <div className='w-100 pb-4 mt-2' style={{ borderTop: '1px solid #e7e7e7' }}>
                                    <div className="flexc flex-1 py-2" style={{ alignItems: 'baseline' }}>
                                        <div className="mrd-3 w-100">
                                            <p className="font-size-14 weight-600 main-c2" style={{}}>{translate("Total")}</p>
                                        </div>
                                        <div className='d-flex flex-column w-100' style={{ alignItems: 'flex-end' }}>
                                            <p className='font-size-16 weight-600 main-c2'>S$622.08 SGD</p>
                                            <p className='font-size-12 main-c7'>{translate('One time full payment')}</p>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                    {this.props.errors && (typeof this.props.errors == 'string') && (
                        <div className="col-12 text-start">
                            <small style={{ color: '#ee5050' }}>{checkTextTranslation(this.props.errors)}</small>
                        </div>
                    )}
                </section>
            )
        } else {
            return (<div></div>)
        }
    }
}

export default InvoiceInput2;